import { createLegacyModule } from "./createLegacyModule";

const keys = [
  "name",
  "tabBarBrand",
  "语言",
  "addres",
  "address",
  "After the recall can not be restored, please choose carefully!",
  "Agree",
  "all",
  "app Enter",
  "app join",
  "appTotal",
  "Back",
  "bigTable",
  "Birthday concession",
  "Booked",
  "Booking record",
  "business hours",
  "call off line up",
  "Cancelle",
  "Cancelled",
  "Cancel queue",
  "Coming soon",
  "Completed",
  "Confirm",
  "Continue to submit",
  "Coupon for newer",
  "Current call number",
  "Dead number",
  "Delivery takes",
  "Discounted price",
  "Eat In",
  "Eat in the store",
  "Enjoy your meal!",
  "Enter your promo code",
  "Hot",
  "I have read and accept the terms and conditions and the privacy policy.",
  "I have read and agree_",
  "immediately",
  "In-store pickup service agreement",
  "Is it sure to delete the order?",
  "It's your turn.",
  "Lunch box fee",
  "New",
  "No reservation record!",
  "ONE off",
  "Online payment",
  "Order here!",
  "Order notes",
  "Order type",
  "Order without registration",
  "Pay at the store",
  "Payment method",
  "person",
  "Personal Message",
  "phone",
  "Please enter reserved phone",
  "Please input your comments",
  "Please input your opinion, thank you",
  "Promotion Message",
  "Queuing Terms and Rules",
  "register",
  "regulatio",
  "remark",
  "Reserved call",
  "Seate",
  "Seated",
  "Self-collection time",
  "send",
  "Sign in",
  "smallTable",
  "Submission of orders",
  "Submit orders",
  "Table type",
  "Taste, preference, etc",
  "Telephone",
  "The restaurant address",
  "The serviece is not available and please contact with the staff.",
  "The store to pay",
  "The ticket time",
  "upload pictures",
  "Vouchers_all",
  "Vouchers_t",
  "Waiting tables",
  "yesterday",
  "Your details can not be saved if you are not sign in. Please sign in or use screenshots to review details."
];

export default createLegacyModule(keys);
